import { Routes } from '@angular/router';
import { RegisterComponent } from './views/pages/register/register.component';
import { LayoutRegisterComponent } from './views/layout-register/layout-register.component';
import { VerificationComponent } from './views/pages/verification/verification.component';
import { CompleteDataComponent } from './views/pages/complete-data/complete-data.component';
import { LayoutAssessmentComponent } from './views/layout-assessment/layout-assessment.component';
import { LayoutAssessmentFutureComponent } from './views/layout-assessment-future/layout-assessment-future.component';
import { LayoutResultComponent } from './views/layout-result/layout-result.component';
import { DashboardComponent } from './views/dashboard/dashboard.component';
import { ProfileComponent } from './views/pages/profile/profile.component';
import { authGuard } from './core/shared/guards/auth.guard';
import { AuthRedirectComponent } from './views/pages/auth/auth-redirect/auth-redirect.component';
import { RecoverPasswordComponent } from './views/pages/recover-password/recover-password.component';
import { ResetPasswordComponent } from './views/pages/reset-password/reset-password.component';
import { NotFoundComponent } from './views/pages/errors/not-found/not-found.component';
import { EditProfileComponent } from './views/pages/profile/edit-profile/edit-profile.component';
import { DashboardMenuComponent } from './views/pages/dashboard-menu/dashboard-menu.component';
import { TermsConditionsComponent } from './views/pages/terms-conditions/terms-conditions.component';
import { TestKnowledgeComponent } from './views/pages/descubrete/test-knowledge/test-knowledge.component';
import { PRDComponent } from './views/pages/descubrete/prd/prd.component';
import { ObjectivesComponent } from './views/pages/descubrete/objectives/objectives.component';
import { NewObjectiveComponent } from './views/pages/descubrete/objectives/new-objective/new-objective.component';
import { PrivacyPoliciesComponent } from './views/pages/privacy-policies/privacy-policies.component';
import { CircleLifeComponent } from './views/pages/descubrete/circle-life/circle-life.component';
import { IdentityMapComponent } from './views/pages/descubrete/identity-map/identity-map.component';
import { MentorsComponent } from './views/pages/mentors/mentors.component';
import { MentorProfileComponent } from './views/pages/mentors/mentor-profile/mentor-profile.component';
import { ScheduleAppointmentComponent } from './views/pages/mentors/schedule-appointment/schedule-appointment.component';
import { PaymentComponent } from './views/pages/payment/payment.component';
import { PlansViewComponent } from './views/pages/plans-view/plans-view.component';
import { AdminComponent } from './views/pages/admin/admin.component';
import { VideosConfigComponent } from './views/pages/admin/videos-config/videos-config.component';
import { UsersManagementComponent } from './views/pages/admin/users-management/users-management.component';
import { RolesManagementComponent } from './views/pages/admin/roles-management/roles-management.component';
import { AdminGuard } from './core/guards/admin.guard';
import { ProfileMentorComponent } from './views/pages/profile/profile-mentor/profile-mentor.component';
import { HerramientasComponent } from './views/pages/herramientas/herramientas.component';
import { VisionboardEditorComponent } from './views/pages/herramientas/visionboard-editor/visionboard-editor.component';
import { AcademyComponent } from './views/pages/academy/academy.component';
import { CoursePlayerComponent } from './views/pages/academy/course-player/course-player.component';
import { AdminVideosComponent } from './views/pages/admin/admin-videos/admin-videos.component';
import { DashboardCoachComponent } from './views/pages/dashboard-coach/dashboard-coach.component';
import { DashboardExecutiveComponent } from './views/pages/dashboard-executive/dashboard-executive.component';
import { DashboardExpertComponent } from './views/pages/dashboard-expert/dashboard-expert.component';
import { USER_TYPES } from './core/shared/constants';
import { UsersAssignedComponent } from './views/pages/mentors/users-assigned/users-assigned.component';
import { UsersAssignedProfileComponent } from './views/pages/mentors/users-assigned-profile/users-assigned-profile.component';
import { CoachManagementComponent } from './views/pages/admin/coach-management/coach-management.component';
import { ExpertsManagementComponent } from './views/pages/admin/experts-management/experts-management.component';
import { AccountManagementComponent } from './views/pages/admin/account-management/account-management.component';
import { AcademyCategoriesManagementComponent } from './views/pages/admin/academy-categories-management/academy-categories-management.component';
import { ExpertCategoriesManagementComponent } from './views/pages/admin/expert-categories-management/expert-categories-management.component';
import { ContactUsComponent } from './views/pages/contact-us/contact-us.component';
import { VisionboardViewComponent } from './views/pages/descubrete/visionboard-view/visionboard-view.component';
import { IkigaiComponent } from './views/pages/herramientas/ikigai/ikigai.component';
import { MeetComponent } from './views/pages/meet/meet.component';
import { MiMentorComponent } from './views/pages/mi-mentor/mi-mentor.component';
import { PriorizacionComponent } from './views/pages/plan-vida/priorizacion/priorizacion.component';
import { RevisionComponent } from './views/pages/plan-vida/revision/revision.component';
import { IkigaiPlanVidaComponent } from './views/pages/plan-vida/ikigai/ikigai.component';
import { AgendaComponent } from './views/pages/agenda/agenda.component';
import { GananciasComponent } from './views/pages/ganancias/ganancias.component';

export const routes: Routes = [
  { path: '', redirectTo: 'auth', pathMatch: 'full' },
  {
    path: 'auth/redirect',
    loadComponent: () =>
      import(
        './views/pages/auth/public-redirect/public-redirect.component'
      ).then(x => x.PublicRedirectComponent)
  },
  {
    path: 'auth',
    component: LayoutRegisterComponent,
    children: [
      { path: '', component: RegisterComponent, canActivate: [authGuard] },
      { path: 'redirect-to', component: AuthRedirectComponent, canActivate: [authGuard] },
      { path: 'verification', component: VerificationComponent },
      { path: 'complete-data', component: CompleteDataComponent, canActivate: [authGuard] },
      { path: 'recover-password', component: RecoverPasswordComponent },
      { path: 'reset-password', component: ResetPasswordComponent },
    ]
  },
  { path: 'terms-conditions', component: TermsConditionsComponent },
  { path: 'privacy-policies', component: PrivacyPoliciesComponent },
  { path: 'contact-us', component: ContactUsComponent },
  {
    path: 'dashboard',
    canActivate: [authGuard],
    component: DashboardComponent,
    children: [
      { path: '', redirectTo: 'edit-profile', pathMatch: 'full' },
      { path: 'complete-profile', component: ProfileComponent },
      { path: 'edit-profile', component: EditProfileComponent },
      { path: 'profile-mentor', component: ProfileMentorComponent },
      { path: 'dashboard-menu', component: DashboardMenuComponent },
      { path: 'dashboard-coach', component: DashboardCoachComponent },
      { path: 'dashboard-expert', component: DashboardExpertComponent },
      { path: 'dashboard-executive', component: DashboardExecutiveComponent },
      { path: 'users-assigned', component: UsersAssignedComponent },
      { path: 'users-assigned/:id', component: UsersAssignedProfileComponent },
      { path: 'agenda', component: AgendaComponent },
      { path: 'ganancias', component: GananciasComponent },
      { path: 'dashboard-experto', component: DashboardExpertComponent },
      { path: 'life-circle', component: TestKnowledgeComponent },
      { path: 'prd', component: PRDComponent },
      { path: 'objectives', component: ObjectivesComponent },
      { path: 'new-objective', component: NewObjectiveComponent },
      { path: 'life-map', component: CircleLifeComponent },
      { path: 'identity-map', component: IdentityMapComponent },
      { path: 'mentors', component: MentorsComponent },
      { path: 'mentor/:id', component: MentorProfileComponent },
      { path: 'schedule/:id', component: ScheduleAppointmentComponent },
      { path: 'plans', component: PlansViewComponent },
      { path: 'payment', component: PaymentComponent },
      { path: 'herramientas', component: HerramientasComponent },
      { path: 'visionboard', component: VisionboardViewComponent },
      { path: 'ikigai', component: IkigaiComponent },
      { path: 'academy', component: AcademyComponent },
      { path: 'academy-vista', component: AcademyComponent, data: { forceCustomerView: true } },
      { path: 'academy/course/:id', component: CoursePlayerComponent },
      { path: 'academy/paper/:id', loadComponent: () => import('./views/pages/academy/paper-detail/paper-detail.component').then(m => m.PaperDetailComponent) },
      { path: 'config', component: ProfileComponent },
      { path: 'mi-mentor', component: MiMentorComponent },
      { path: 'meet/:appointmentId', component: MeetComponent },
      { path: 'priorizacion', component: PriorizacionComponent },
      { path: 'revision', component: RevisionComponent },
      { path: 'ikigai-plan-vida', component: IkigaiPlanVidaComponent },
      {
        path: 'admin',
        component: AdminComponent,
        canActivate: [AdminGuard],
        children: [
          { path: '', redirectTo: 'users', pathMatch: 'full' },
          {
            path: 'users', component: UsersManagementComponent,
            data: {
              userTypeId: USER_TYPES.Customer.id,
              pageTitle: 'Administración de Usuarios'
            }
          },
          {
            // path: 'mentors', component: UsersManagementComponent,
            path: 'mentors', component: CoachManagementComponent,
            data: {
              userTypeId: USER_TYPES.Coach.id,
              pageTitle: 'Administración de Mentores'
            }
          }, // nuevo componente para 
          {
            // path: 'experts', component: UsersManagementComponent,
            path: 'experts', component: ExpertsManagementComponent,
            data: {
              userTypeId: USER_TYPES.Expert.id,
              pageTitle: 'Administración de Expertos'
            }
          }, // nuevo componente para 
          {
            // path: 'accounts', component: UsersManagementComponent,
            path: 'accounts', component: AccountManagementComponent,
            data: {
              pageTitle: 'Administración de cuentas'
            }
          }, // nuevo componente para 
          { path: 'roles', component: RolesManagementComponent },
          { path: 'videos-config', component: VideosConfigComponent },
          { path: 'admin-videos', component: AdminVideosComponent },
          { path: 'academy-video-categories', component: AcademyCategoriesManagementComponent },
          { path: 'expert-categories', component: ExpertCategoriesManagementComponent },
        ]
      }
    ]
  },
  {
    path: 'assessment',
    canActivate: [authGuard],
    component: LayoutAssessmentComponent,
  },
  {
    path: 'assessment-future',
    canActivate: [authGuard],
    component: LayoutAssessmentFutureComponent,
  },
  {
    path: 'results',
    canActivate: [authGuard],
    component: LayoutResultComponent,
  },
  {
    path: 'not-found',
    component: NotFoundComponent,
  },
  { path: '**', redirectTo: '/not-found' }
];
